

define(['angular', 'squid/index', './directive', 'pages/xo-sidebar/route', 'xo-guest-components/src/guest-upgrade-interstitial/route', 'xo-guest-components/src/continue-3ds-redirect/route'], function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-signup.route', ['squid', 'hermes.page.xo-signup.directive', 'hermes.page.xo-sidebar.route']).factory('$SignupRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('SignupRoute', {
      name: 'signup',
      directive: 'xo-signup',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'accountCreationGuest.heading',

      trackingData: {
        fptiState: 'signup',
        trackStateExit: false,
        templateName: 'signup.dust',
        pageGoal: 'Signup Start',
        pageQualifier: 'signup',
        buzname: {
          'signup': {
            'pagename': '%::fullpage-signup',
            'pagename2': '%::fullpage-signup:member:hermes:',
            'version': 'guest:%:'
          }
          // More page qualifiers come here...
        }
      },
      children: [{
        name: '$SidebarRoute',
        attributes: {
          'back-uri': 'backUri',
          'parent-model': 'singleStepModel'
        }
      }, {
        name: '$GuestUpgradeInterstitialRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      },
      /**
       * Url endpoint: checkout/signup/continue3DSRedirect
       * This endpoint is need to call the existing client method `onComplete3DSHandler` 
       * so that once after complete3DS success in full page redirection of bank page to 
       * continue the 3ds process.
       */
      {
        name: '$Continue3DSRedirectRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      }]
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-signup/route.js
// module id = ./pages/xo-signup/route.js
// module chunks = 0